import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GungAnonymousConfigService {

  public showAnonymousPrices: boolean = false;
  public showAnonymousAvailabilities: boolean = false;

}
